import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section className="about-us-section py-5">
      <div className="container">
        <div className="about-us-card">
          <h1 className="about-us-title">About Us</h1>
          
          <div className="about-us-content">
            <p>
              HealthWiibes is a health related website, and provides health related tools to people although right now it has only one tool which is ideal BMI calculator but in future we will add many new tools to our website. We might also write article for our tools which help users to understad about tools and how to use them accurately. This ideal weight calculator tool also provides you best diet plans.
            </p>
            
            <p>
              To keep HealthWiibes running online, we support our servers by displaying Google ads, which are safe and non-intrusive. You can read our privacy policy and terms of service anytime.
            </p>
            
            <div className="contact-box">
              <h3>Contact Us</h3>
              <p>
                In the future, if you have any query, suggestions, bug reports, or advertisement proposals, then contact us anytime by using our email address:
              </p>
              <a href="mailto:healthwiibes@gmail.com" className="email-link">
                healthwiibes@gmail.com
              </a>
              <p className="sharing-text">
                We believe if you like our work and efforts for you, then you can share it with your friends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;